export const MATCHES_COLLECTION = 'matches-v8';
export const PLAYERS_COLLECTION = 'players-v8';
